import React, { useEffect, useRef, useState } from 'react';

const CarnetModal = ({ isOpen, onClose, pdfBlob, filename = 'carnet.pdf' }) => {
  const [objectUrl, setObjectUrl] = useState(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    if (pdfBlob) {
      const url = URL.createObjectURL(pdfBlob);
      setObjectUrl(url);
      return () => {
        URL.revokeObjectURL(url);
        setObjectUrl(null);
      };
    } else {
      setObjectUrl(null);
    }
  }, [isOpen, pdfBlob]);

  const handlePrint = () => {
    // Intentar imprimir el contenido del iframe
    try {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.focus();
        iframeRef.current.contentWindow.print();
        return;
      }
    } catch (e) {
      // Fallback a nueva pestaña si no se puede acceder al iframe
    }
    // Fallback: abrir en nueva pestaña y dejar que el usuario imprima
    if (objectUrl) {
      window.open(objectUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleDownload = () => {
    if (!objectUrl) return;
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleOpenNew = () => {
    if (objectUrl) window.open(objectUrl, '_blank', 'noopener,noreferrer');
  };

  if (!isOpen) return null;

  return (
    <div className="modal" style={{ zIndex: 2100 }}>
      <div className="modal-content" style={{ width: '90%', maxWidth: 900, height: '80vh', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-header">
          <h3>Carnet de Socia</h3>
          <button onClick={onClose} className="close-btn">
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn-primary" onClick={handlePrint} title="Imprimir">
              <i className="fas fa-print"></i> Imprimir
            </button>
            <button className="btn-secondary" onClick={handleDownload} title="Descargar PDF">
              <i className="fas fa-download"></i> Descargar
            </button>
            <button className="btn-secondary" onClick={handleOpenNew} title="Abrir en nueva pestaña">
              <i className="fas fa-external-link-alt"></i> Abrir
            </button>
          </div>

          <div style={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', background: '#f8f9fa' }}>
            {objectUrl ? (
              <iframe
                ref={iframeRef}
                title="Vista previa carnet"
                src={objectUrl}
                style={{ width: '100%', height: '100%', border: 'none' }}
              />
            ) : (
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#666' }}>
                <i className="fas fa-file-pdf" style={{ fontSize: 32, marginRight: 10 }}></i>
                No hay contenido para mostrar
              </div>
            )}
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default CarnetModal;
